import { i as k, b as f, n as r, t as u, P as _ } from "./element-CV9utnHJ.js";
import { e as y } from "./class-map-3ADKve8g.js";
import { P as v } from "./pkt-slot-controller-D7CrjM52.js";
import { e as m, n as h } from "./ref-Dma3n3i8.js";
import { o as $ } from "./if-defined-rXcLNTzN.js";
var b = Object.defineProperty, P = Object.getOwnPropertyDescriptor, d = (t, e, a, o) => {
  for (var i = o > 1 ? void 0 : o ? P(e, a) : e, n = t.length - 1, c; n >= 0; n--)
    (c = t[n]) && (i = (o ? c(e, a, i) : c(i)) || i);
  return o && i && b(e, a, i), i;
};
let p = class extends k {
  constructor() {
    super(...arguments), this.ariaLabelledBy = "", this.compact = !1, this.skin = "borderless", this.name = "";
  }
  updated(t) {
    t.has("skin") && this.requestUpdate(), t.has("name") && this.updateAccordionItemNames();
  }
  updateAccordionItemNames() {
    var t;
    if (this.name) {
      const e = (t = this.renderRoot) == null ? void 0 : t.querySelector("slot");
      e && e.assignedElements().forEach((o) => {
        o.tagName.toLowerCase() === "pkt-accordion-item" && (o.hasAttribute("name") || o.setAttribute("name", this.name));
      });
    }
  }
  firstUpdated() {
    var e;
    const t = (e = this.renderRoot) == null ? void 0 : e.querySelector("slot");
    t && t.addEventListener("slotchange", () => {
      this.updateAccordionItemNames();
    });
  }
  render() {
    const t = {
      "pkt-accordion": !0,
      "pkt-accordion--compact": this.compact,
      [`pkt-accordion--${this.skin}`]: this.skin
    };
    return f`
      <div
        part="container"
        class=${y(t)}
        data-testid="pkt-accordion"
        aria-labelledby=${this.ariaLabelledBy}
      >
        <slot></slot>
      </div>
    `;
  }
};
d([
  r({ type: String, reflect: !0, attribute: "aria-labelledby" })
], p.prototype, "ariaLabelledBy", 2);
d([
  r({ type: Boolean, reflect: !0, attribute: "compact" })
], p.prototype, "compact", 2);
d([
  r({ type: String, reflect: !0, attribute: "skin" })
], p.prototype, "skin", 2);
d([
  r({ type: String, reflect: !0, attribute: "name" })
], p.prototype, "name", 2);
p = d([
  u("pkt-accordion")
], p);
const C = p;
var O = Object.defineProperty, g = Object.getOwnPropertyDescriptor, l = (t, e, a, o) => {
  for (var i = o > 1 ? void 0 : o ? g(e, a) : e, n = t.length - 1, c; n >= 0; n--)
    (c = t[n]) && (i = (o ? c(e, a, i) : c(i)) || i);
  return o && i && O(e, a, i), i;
};
let s = class extends _ {
  constructor() {
    super(), this.defaultOpen = !1, this.title = "", this.skin = void 0, this.compact = !1, this.isOpen = !1, this.name = void 0, this.accordionItemRef = m(), this.defaultSlot = m(), this.slotController = new v(this, this.defaultSlot);
  }
  firstUpdated(t) {
    this.defaultOpen && (this.isOpen = !0);
  }
  render() {
    const t = {
      "pkt-accordion-item": !0,
      "pkt-accordion-item--compact": this.compact,
      [`pkt-accordion-item--${this.skin}`]: !!this.skin
    };
    return f`
      <details
        class=${y(t)}
        id=${this.id}
        ?open=${this.isOpen}
        ${h(this.accordionItemRef)}
        name=${$(this.name)}
      >
        <summary class="pkt-accordion-item__title" id=${`pkt-accordion-item-summary-${this.id}`}>
          ${this.title}
          <pkt-icon
            name="chevron-thin-down"
            class="pkt-accordion-item__icon"
            aria-hidden="true"
          ></pkt-icon>
        </summary>
        <div
          class="pkt-accordion-item__content"
          id="pkt-accordion-item__content-${this.id}"
          role="region"
        >
          <div class="pkt-accordion-item__content-inner" ${h(this.defaultSlot)}></div>
        </div>
      </details>
    `;
  }
};
l([
  r({ type: Boolean })
], s.prototype, "defaultOpen", 2);
l([
  r({ type: String })
], s.prototype, "title", 2);
l([
  r({ type: String, reflect: !0 })
], s.prototype, "skin", 2);
l([
  r({ type: Boolean, reflect: !0 })
], s.prototype, "compact", 2);
l([
  r({ type: Boolean, reflect: !0 })
], s.prototype, "isOpen", 2);
l([
  r({ type: String, reflect: !0 })
], s.prototype, "name", 2);
s = l([
  u("pkt-accordion-item")
], s);
const E = s;
export {
  C as P,
  E as a
};
